<div class="page-container" [class.loading]="isLoading">
    <app-header
        title="{{ 'company.calendar-feeds.header' | translate }}"
        [menuService]="companyMenuService"
    ></app-header>

    <div class="ui table segment">
        <app-segment-header title="{{ 'company.calendar-feeds.feedsSectionHeader' | translate }}"></app-segment-header>
        <p class="margin-left-5">{{ 'company.calendar-feeds.doNotShareWarningMessage' | translate }}</p>
        <table class="ui fixed table">
            <thead>
                <tr>
                    <th>{{ 'company.calendar-feeds.nameColumn' | translate }}</th>
                    <th>{{ 'company.calendar-feeds.descriptionColumn' | translate }}</th>
                    <th>{{ 'company.calendar-feeds.urlColumn' | translate }}</th>
                    <th class="two wide">{{ 'company.calendar-feeds.subscribeColumn' | translate }}</th>
                </tr>
            </thead>

            <tbody *ngIf="feeds.length > 0; else emptyState">
                <tr *ngFor="let feed of feeds">
                    <td>{{ feed.label | appTranslateOptions: calendarFeedDisplayOptions }}</td>
                    <td
                        [innerHTML]="feed.description | appTranslateOptions: calendarFeedDescriptionDisplayOptions"
                    ></td>
                    <td class="breakable">{{ feed.url }}</td>
                    <td>
                        <a [href]="sanitize(feed.url)" class="icon">
                            <mat-icon svgIcon="subscribe"></mat-icon>
                        </a>
                    </td>
                </tr>
            </tbody>

            <ng-template #emptyState>
                <tbody class="empty">
                    <tr>
                        <td colspan="4">
                            <app-empty-state
                                label="company.calendar-feeds.noCalendarFeeds"
                                src="/assets/illustrations/empty-box.png"
                            ></app-empty-state>
                        </td>
                    </tr>
                </tbody>
            </ng-template>
        </table>
    </div>

    <div class="ui half-size segment">
        <app-segment-header title="{{ 'company.calendar-feeds.helpSectionHeader' | translate }}"></app-segment-header>

        <div>
            <app-segment-header
                [collapsible]="true"
                [collapsed]="true"
                title="{{ 'company.calendar-feeds.googleHelpSectionHeader' | translate }}"
            ></app-segment-header>
            <div class="content" [innerHTML]="'company.calendar-feeds.googleHelpSectionContent' | translate"></div>
        </div>

        <div class="ui divider"></div>
        <div>
            <app-segment-header
                [collapsed]="true"
                [collapsible]="true"
                title="{{ 'company.calendar-feeds.appleHelpSectionHeader' | translate }}"
            ></app-segment-header>
            <div class="content" [innerHTML]="'company.calendar-feeds.appleHelpSectionContent' | translate"></div>
        </div>

        <div class="ui divider"></div>
        <div>
            <app-segment-header
                [collapsible]="true"
                [collapsed]="true"
                title="{{ 'company.calendar-feeds.outlookHelpSectionHeader' | translate }}"
            ></app-segment-header>
            <div class="content" [innerHTML]="'company.calendar-feeds.outlookHelpSectionContent' | translate"></div>
        </div>
    </div>
</div>
